var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-icon-menu"},[_c('div',{staticClass:"header-icon-menu__container",on:{"click":_vm.onClick}},_vm._l((3),function(item,i){return _c('div',{key:i,class:("header-icon-menu__stroke-" + (i + 1))})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }